import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/higuma-icon.png'
import _imports_1 from '../assets/images/talk_icon.svg'
import _imports_2 from '../assets/images/parent_and_child.png'
import _imports_3 from '../assets/images/salmon.png'


const _withScopeId = n => (_pushScopeId("data-v-4d031b2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-50 bg-baseBrown" }
const _hoisted_2 = { class: "main_section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-darkBrown text-xl bold" }, "子育てスナック"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "color-darkBrown text-2xl bold" }, "ひぐまさんの相談部屋")
], -1))
const _hoisted_4 = { class: "top_message mt-25" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ひぐまさんアイコン",
  class: "top_message_icon"
}, null, -1))
const _hoisted_6 = { class: "speech_bubble left top_message_comment p-15" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, "ひぐまさんに愚痴りませんか?", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "トークアイコン",
  class: "top_message_talk_icon"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "color-annotation text-xs mt-15" }, "ひぐまさんとの会話をスタート", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "higmas_img mt-45" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "ひぐまさん親子"
  })
], -1))
const _hoisted_11 = { class: "pt-50 pb-50" }
const _hoisted_12 = { class: "main_section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "center text-xl bold" }, "ひぐまさんの相談部屋とは?", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base p-10 mt-25" }, [
  /*#__PURE__*/_createTextVNode(" 毎日の子育ての中での色々な悩みやモヤモヤをワンオペくまのひぐまさんにお話してみませんか？"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" あなたがどんなことで悩んでいるのか、ひぐまさんが受け取って、あなたの代わりに色々調べてきます！ ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "salmon_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "さけ"
  })
], -1))
const _hoisted_16 = { class: "step_item_sign color-white bold bg-darkBrown" }
const _hoisted_17 = { class: "text-sm bold" }
const _hoisted_18 = { class: "step_item_message mt-10" }
const _hoisted_19 = { class: "text-xs speech_bubble right pt-5 pb-5 pl-15 pr-15" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ひぐまさんアイコン",
  class: "step_item_icon"
}, null, -1))
const _hoisted_21 = { class: "pt-50 pb-100 bg-baseBrown" }
const _hoisted_22 = { class: "main_section" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "center text-xl bold color-darkBrown" }, "ひぐまさんの３つの約束", -1))
const _hoisted_24 = { class: "mt-35" }
const _hoisted_25 = { class: "text-lg bold center" }
const _hoisted_26 = { class: "text-sm mt-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuArea = _resolveComponent("MenuArea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_router_link, {
              to: "/room",
              class: "top_message_talk_icon mt-25"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9
          ])
        ]),
        _hoisted_10
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("section", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
            return (_openBlock(), _createElementBlock("li", {
              key: step.id,
              class: "step_item bg-baseBrown-50"
            }, [
              _createElementVNode("div", _hoisted_16, " STEP" + _toDisplayString(step.id), 1),
              _createElementVNode("p", _hoisted_17, _toDisplayString(step.content), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(step.message), 1),
                _hoisted_20
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("section", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("ul", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promise, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: "promise_item bg-white"
            }, [
              _createElementVNode("h3", _hoisted_25, _toDisplayString(item.id) + "." + _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_26, _toDisplayString(item.content), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isMenuShow)
          ? (_openBlock(), _createBlock(_component_MenuArea, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}